import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, throwError } from 'rxjs';
import { BasemodelService } from 'src/app/basemodel.service';
 import { environment } from 'src/environments/environment.development';
@Injectable({
  providedIn: 'root'
})
export class StudentAttendanceService {
 private token5 = '';
  private apiurl = environment.masterDomain;
  private attendancesurl = environment.attendanceDomain;

  private get jwtToken(): string {
    return localStorage.getItem('token') ?? '';
  }

  constructor(private http: HttpClient, private baseurl: BasemodelService) {}

  //----- Student Atteandances---------------//
  getstudentcount(attendanceDate: string) {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token5,
      'Content-Type': 'application/json'
    });
    return this.http.get(
      this.attendancesurl + '/employee/api/jwtV2/overallStdAttendanceDashboardCount?jwtToken=' + this.jwtToken + '&attendanceDate=' + attendanceDate,
      { headers },
    );
  }

  getstudentclass() {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token5,
      'Content-Type': 'application/json'
    });
    return this.http.get(this.apiurl + "/employee/api/jwtV2/getClassList", { headers });
  }

  getstundentbuilding() {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token5,
      'Content-Type': 'application/json'
    });
    return this.http.get(this.apiurl + "/employee/api/jwtV2/getCmpBuilding", { headers });
  }

  getstudentsection(classId: any, buildingId: any): Observable<any[]> {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token5,
      'Content-Type': 'application/json'
    });
    return this.http.get(
      this.apiurl + '/employee/api/jwtV2/getBuildingSections?buildingId=' + buildingId + '&classId=' + classId,
      { headers }
    ).pipe(
      map((res: any) => (Array.isArray(res) ? res : [])),
      catchError((err) => {
        if (err?.status === 204 || err?.status === 404) {
          return of([]);
        }
        return throwError(() => err);
      })
    );
  }

  getsectionSummary(sectionId: any, attendanceDate: string) {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token5,
      'Content-Type': 'application/json'
    });
    return this.http.get(
      this.attendancesurl + '/employee/api/jwtV2/sectionSummary?sectionId=' + sectionId + '&attendanceDate=' + attendanceDate + '&jwtToken=' + this.jwtToken,
      { headers },
    );
  }

  /** GET getSectionsStudents — always returns an array (empty [] is valid 200). */
  getSectionStudentAttendance(sectionId: any, attendanceDate: string): Observable<any[]> {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token5,
      'Content-Type': 'application/json'
    });
    return this.http.get(
      this.attendancesurl + '/employee/api/jwtV2/getSectionsStudents?sectionId=' + sectionId + '&attendanceDate=' + attendanceDate + '&jwtToken=' + this.jwtToken,
      { headers },
    ).pipe(
      map((res: any) => this.normalizeStudentList(res)),
      catchError((err) => {
        // 204 / empty body → treat as no students
        if (err?.status === 204 || err?.status === 404) {
          return of([]);
        }
        return throwError(() => err);
      })
    );
  }

  private normalizeStudentList(res: any): any[] {
    if (!res) {
      return [];
    }
    if (Array.isArray(res)) {
      return res;
    }
    if (Array.isArray(res.students)) {
      return res.students;
    }
    if (Array.isArray(res.studentList)) {
      return res.studentList;
    }
    if (Array.isArray(res.data)) {
      return res.data;
    }
    return [];
  }

  saveattendances(section: any, payload: any) {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.token5,
      'Content-Type': 'application/json'
    });
    return this.http.post(
      this.attendancesurl + '/employee/api/jwtV2/saveSpWiseStdAttendance?sectionId=' + section + '&jwtToken=' + this.jwtToken,
      payload,
      { headers },
    );
  }
}
